import CallPhoneIcon from './CallPhone.icon';

export default CallPhoneIcon;
